import React, { useState } from 'react';
import { FlatList, RefreshControl, TextInput, TouchableOpacity, View } from 'react-native';
import { useQuery } from '@tanstack/react-query';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useNavigation } from '@react-navigation/native';

import api from '../../../utils/api';
import tw from '../../../styles/tailwind';
import Text from '../../../components/Text';

type Community = {
  uuid: string;
  name: string;
  units_count?: number;
  residents_count?: number;
  access_control_panels_count?: number;
};

type Page = { data: Community[] };

export default function CommunitiesListScreen() {
  const navigation = useNavigation<any>();
  const [q, setQ] = useState('');

  const { data, isLoading, refetch } = useQuery<Page>({
    queryKey: ['meta.communities', q],
    queryFn: () => api.get('/admin/communities', { params: { q } }).then(r => r.data),
  });

  return (
    <SafeAreaView style={tw`flex-1 bg-background`}>
      <View style={tw`p-4`}>
        <Text style={tw`text-xl font-600 text-gray-800 mb-2`}>Fraccionamientos</Text>
        <TextInput
          style={tw`bg-white border border-gray-200 rounded px-3 py-2`}
          placeholder="Buscar..."
          value={q}
          onChangeText={setQ}
          autoCapitalize="none"
          autoCorrect={false}
        />
      </View>

      <FlatList
        data={data?.data ?? []}
        keyExtractor={c => c.uuid}
        refreshControl={<RefreshControl onRefresh={refetch} refreshing={isLoading} />}
        ListEmptyComponent={
          <View style={tw`items-center mt-10`}>
            <Text>{isLoading ? 'Cargando…' : 'Sin resultados'}</Text>
          </View>
        }
        renderItem={({ item }) => (
          <TouchableOpacity
            style={tw`bg-white px-4 py-3 mx-4 mb-2 rounded`}
            onPress={() => navigation.navigate('MetaAdmin.Communities.Detail', { uuid: item.uuid })}
          >
            <Text style={tw`text-gray-800 font-500`}>{item.name}</Text>
            <Text style={tw`text-gray-500 text-xs`}>
              {item.units_count ?? 0} viviendas · {item.residents_count ?? 0} residentes ·{' '}
              {item.access_control_panels_count ?? 0} paneles
            </Text>
          </TouchableOpacity>
        )}
      />
    </SafeAreaView>
  );
}
